module.exports = __webpack_public_path__ + "static/img/pay.a1138271.png";